// extracted by mini-css-extract-plugin
export default {"labReportCombinedStatusContainer":"LabReportCombinedStatusComponent_labReportCombinedStatusContainer__vOiK8"};